/**
 * Конфигурация переменных окружения
 */
export const env = {
  // В production используем пустую строку (относительные URL), в dev - localhost
  apiUrl: import.meta.env.VITE_API_URL !== undefined 
    ? import.meta.env.VITE_API_URL 
    : (import.meta.env.DEV ? 'http://localhost:3001' : ''),
  webappUrl: import.meta.env.VITE_WEBAPP_URL || 'http://localhost:5173',
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
  // Флаг для использования mock Telegram SDK в режиме разработки
  // Установите VITE_USE_MOCK_TELEGRAM=false для отключения mock
  useMockTelegram: import.meta.env.VITE_USE_MOCK_TELEGRAM !== 'false',
} as const

